var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLif3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_8566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3164 30C23.6007 30 30.3164 23.2843 30.3164 15C30.3164 6.71573 23.6007 0 15.3164 0C7.03214 0 0.316406 6.71573 0.316406 15C0.316406 23.2843 7.03214 30 15.3164 30Z",
    fill: "url(#paint0_radial_11_8566)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_8566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3407 7.8447C14.1843 8.0019 14.0695 8.19306 14.0034 8.40096L9.76562 19.6887H8.0564V21.42H11.2935L12.5409 17.9773L13.1345 16.2466L15.2925 10.1182L19.2724 21.42H22.5757V19.6887H20.8599L16.6225 8.4006C16.5564 8.19288 16.4415 8.00178 16.2852 7.8447C16.0273 7.58556 15.6776 7.44 15.313 7.44C14.9483 7.44 14.5986 7.58556 14.3407 7.8447Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_8566",
    x: 4.0564,
    y: 7.44,
    width: 22.5193,
    height: 21.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_8566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_8566",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11_8566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.316406) rotate(45) scale(42.4264 28.5265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79A5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616783,
    stopColor: "#2A4874"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_8566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.316406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLif3);
export default __webpack_public_path__ + "static/media/lif3.0e4e3f36a248e99c655c037495097620.svg";
export { ForwardRef as ReactComponent };